import type { TranslationTree } from '../../types';

export const camera: TranslationTree = {
  camera: {
    switchCamera: 'Switch camera',
    error: {
      title: 'Camera error',
      description: 'We were unable to access your camera.',
      button: 'Retry',
      notAllowed: 'Camera access was denied — allow access in your browser settings and retry.',
      notFound: 'No camera was found on this device.',
      aborted: 'Camera access was interrupted — please retry.',
      unknown: 'An unexpected camera error occurred ({{name}}).',
      generic: 'Camera is unavailable — please retry.',
    },
  },
};
